import { Injectable } from '@angular/core';
import {LottieAnimState} from "../interfaces/lottie-anim-state";
import {AnimationItem} from "lottie-web";
import {AccessibilityService} from "./accessibility.service";

@Injectable({
  providedIn: 'root'
})
export class LottieHelperService {

  items: LottieAnimState[] = [];

  globalStopMovingContent = false;
  constructor(private accessibilityService: AccessibilityService) {
    this.accessibilityService.getStopMovingContent().subscribe((newValue) => {
      this.globalStopMovingContent = newValue;
    })
  }


  playAnimation(animation: AnimationItem, fps: number) {
    let foundAnim = this.items.find((item) => item.animation === animation);

    if(!foundAnim) {
      foundAnim = {
        animation: animation,
        fps: fps,
        lastFrameTimestamp: 0,
        state: false
      }

      this.items.push(foundAnim);
    } else {
      foundAnim.fps = fps;
    }

    if(!foundAnim.state) {
      foundAnim.state = true;
      this.animFrame(foundAnim);
    }

  }

  pauseAnimation(animation: AnimationItem){
    let foundAnim = this.items.find((item) => item.animation === animation);
    if(!foundAnim) {
      console.warn("Animation was not found! Probably lost...");
      return;
    }

    foundAnim.state = false;
  }

  removeAnimation(animation: AnimationItem) {
    let foundAnim = this.items.find((item) => item.animation === animation);

    if(!foundAnim) {
      console.warn("Animation was not found on destroy! Probably lost...");
      return;
    }

    foundAnim.state = false;
    this.items = this.items.filter(item => item !== foundAnim);

    console.log("Animation was destroyed. Tracked animations: ", this.items.length);
  }

  private animFrame(item: LottieAnimState) {
    if(item.state) {

      const now = Date.now();


      if(now >= (item.lastFrameTimestamp + this.getDelayByFrameRate(item.fps)) && !this.globalStopMovingContent) {
        let nextFrame = item.animation.currentFrame + 1;
        if(nextFrame === item.animation.totalFrames) nextFrame = 0;

        // console.log("Next Frame is", nextFrame, this.animation.totalFrames);
        item.animation.goToAndStop(nextFrame, true);
        item.lastFrameTimestamp = now;

        // console.log(`Frame for ${item.animation.animationID} was set to ${nextFrame}`);
      }


      window.requestAnimationFrame(() => {
        this.animFrame(item);
      });
    }

  }

  private getDelayByFrameRate(fps: number) {
    return 1000 / fps;
  }

}
